module.exports = __webpack_public_path__ + "static/img/admin-elipse-2x.7f8f11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin-elipse-2x.png
// module id = afb0
// module chunks = 1